import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';

import { selectors as rootSelectors } from '../root';
import Table from './components/table';
import ShowActiveCampaignsForm from './components/show-active-campaigns-form';
import Filters from '../shared/filters/main';
import Search from '../shared/search/main';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content campaigns-list">
			<div className="container__content-title">
				<div className="container__content-title-position">
					<h1 className="title">{props.intl('Affiliate campaigns')}</h1>
				</div>
			</div>
			<div className="container__content-body">
				<div className="campaigns-list__filter-position clearfix">
					<Filters {...props} {...props.filters} />
				</div>
				<div className="ui-control-bar">
					<div className="ui-control-bar__item modify-item---search">
						<div className="ui-control-bar__item-position">
							<Search
								form="campaignsSearchForm"
								autoFocus={true}
								action={props.search}
								{...props}
							/>
						</div>
					</div>
					<div className="ui-control-bar__item">
						<ShowActiveCampaignsForm {...props} action={props.search}/>
					</div>
					<div className="ui-control-bar__item">
						<div className="ui-control-bar__item-position">
							<button className="ui-btn ui-btn-primary apply" onClick={props.apply}>
								{props.intl('Apply')}
							</button>
						</div>
					</div>
					<div className="ui-control-bar__item">
						<div className="ui-control-bar__item-position">
							<button className="ui-btn ui-btn-primary apply" onClick={props.exportCsv}>
								{props.intl('Export')}
							</button>
						</div>
					</div>
					<div className="ui-control-bar__item">
						<div className="ui-control-bar__item-position">
							<button className="ui-btn ui-btn-secondary ui-icon-clear" onClick={props.clear} />
						</div>
					</div>
					<div className="ui-control-bar__item">
						<div className="ui-control-bar__item-position">
							<button
								className="ui-btn ui-btn-primary apply autoarchive-btn"
								onClick={() => props.toggleAutoArchiving(props.listedCampaignIds, true)}
							>
								{props.intl('Не автоархивировать все')}
							</button>
						</div>
					</div>
				</div>
				<Table {...props} />
			</div>
		</div>
	</Animate>
), 'view');

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		listedCampaignIds: selectors.getListedCampaignIds(state),
		pagination: selectors.getPagination(state),
		filters: selectors.getFilters(state),
		refererTypeOptions: selectors.getRefererTypeOptions(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		progressBar: selectors.getProgressBar(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/campaigns/main.js